var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvelopeStroke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "envelope-stroke",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1582 0H2.1582C1.3332 0 0.665703 0.675 0.665703 1.5L0.658203 10.5C0.658203 11.325 1.3332 12 2.1582 12H14.1582C14.9832 12 15.6582 11.325 15.6582 10.5V1.5C15.6582 0.675 14.9832 0 14.1582 0ZM14.1582 10.5H2.1582V3L8.1582 6.75L14.1582 3V10.5ZM8.1582 5.25L2.1582 1.5H14.1582L8.1582 5.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeStroke);
export default __webpack_public_path__ + "static/media/envelope-stroke.ca0aa38cdfadc1ff683da8fdd25ad3d9.svg";
export { ForwardRef as ReactComponent };